import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { GetEmailDeliveryFailuresParams, getEmailDeliveryFailures, resendEmail } from '~/services/SailthruService';

export const emailDeliveryFailuresQueryKeys = {
  all: ['emailDeliveryFailures'] as const,
  list: (filters: GetEmailDeliveryFailuresParams) => [...emailDeliveryFailuresQueryKeys.all, 'list', filters] as const,
};

export function useGetEmailDeliveryFailures(filters: GetEmailDeliveryFailuresParams) {
  return useQuery({
    queryKey: emailDeliveryFailuresQueryKeys.list(filters),
    queryFn: ({ signal }) => getEmailDeliveryFailures(filters, signal),
    placeholderData: keepPreviousData,
  });
}

export function useResendEmailDeliveryFailure() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: resendEmail,
    onSuccess: () => {
      enqueueSnackbar('Email successfully resent', { variant: 'success' });
      queryClient.invalidateQueries({ queryKey: emailDeliveryFailuresQueryKeys.all });
    },
    onError: () => {
      enqueueSnackbar('Failed to resend email', { variant: 'error' });
    },
  });
}
